(function (){
    'use strict';

    angular.module('MktzapApp.Factories')
        .factory('SendProposalTelesaqueService', SendProposalTelesaqueService);

    SendProposalTelesaqueService.$inject = ['$resource'];

    function SendProposalTelesaqueService ($resource) {
        return $resource(apiUrl + '/send-proposal-telesaque/:id', { id: '@id' }, {
            getMessageTelesaque: { url: apiUrl + '/message-telesaque-get', method: 'GET', isArray: false },
            getTelesaqueAllowance: { url: apiUrl + '/telesaque-allowance', method: 'GET', isArray: false },
            stoneageValidation: { url: apiUrl + '/stoneage-validation-cpf-cellphone', method: 'POST', params: {}, isArray: false },
            getCetelenProposalInfo: { url: apiUrl + '/get-proposal-info-cetelem', method: 'POST', isArray: false }
        });
    }
})();
